import { IVectorCoordinatable, instanceOfIVectorCoordinatable } from "../../../../base/domain/drawing";
import { IEditableFormatObject, instanceOfEditableFormatObject } from "../IEditableFormatStructure";
import { ElementTypes } from "./ElementTypes";

export interface IVectorCoordinatableObject extends IEditableFormatObject, IVectorCoordinatable {}

export function instanceOfIVectorCoordinatableObject<T extends IVectorCoordinatableObject>(instance: any, type: ElementTypes): instance is IVectorCoordinatableObject {
  return instance
      && instanceOfIVectorCoordinatable(instance)
      && instanceOfEditableFormatObject<T>(instance, type);
}
